export default __webpack_public_path__ + "static/slide02-750b7db013cefecb1a7383479a414bb4.jpg";